import { createContext, createElement, useContext, type ReactNode } from 'react'

// Tenant context is ONE hook (ADR 0003 §4), never per-page state or a query-string convention.
// Standalone Scout serves a single spoke, configured at build time; a hub-hosted portal will
// resolve it from the instance. Either way, pages only ever call useSpoke().
const SpokeContext = createContext<string>(import.meta.env.VITE_SCOUT_SPOKE ?? 'hub')

export function SpokeProvider({ spoke, children }: { spoke?: string; children: ReactNode }) {
  return createElement(SpokeContext.Provider, { value: spoke ?? import.meta.env.VITE_SCOUT_SPOKE ?? 'hub' }, children)
}

export function useSpoke(): string {
  return useContext(SpokeContext)
}
